<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
  />
</template>

<script>
import model from '@/models/option';

export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '角色類型資訊',
                fields: ['sequence', 'locales'],
              },
            ],
          },
        ],
      },
    }
  },
};
</script>